export default __webpack_public_path__ + "static/media/ai_governance_unacceptable_risk.d24d223a.svg";